import QueueLink from 'apollo-link-queue'

const queueLink = new QueueLink()

export default queueLink
